import { render } from "./addCustomerProfile.vue?vue&type=template&id=956e6b42"
import script from "./addCustomerProfile.vue?vue&type=script&lang=js"
export * from "./addCustomerProfile.vue?vue&type=script&lang=js"

import "./addCustomerProfile.vue?vue&type=style&index=0&id=956e6b42&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__